module.exports = __webpack_public_path__ + "static/media/arquitect_9.85cc667c.jpeg";